import React from "react";

import { Button, Tooltip } from "components";

import { ReactComponent as Download } from "static/images/downloadFile.svg";
import { ReactComponent as PlayIcon } from "static/images/play-icon.svg";
import { ReactComponent as Rerun } from "static/images/reset.svg";
import styles from "./checkListRow.module.scss";

type CheckListActionsProps = {
	handleDownload?: Function;
	handleViewResult: Function;
	handleRerun: Function;
	isLoading?: boolean;
	isDownloading?: boolean;
	isDisabled?: boolean;
	isDisabledViewBtn?: boolean;
	showRerun?: boolean;
	btnTooltip?: string;
};

const CheckListActions = ({
	handleDownload,
	handleViewResult,
	handleRerun,
	isLoading = false,
	isDownloading = false,
	isDisabled = false,
	isDisabledViewBtn = false,
	showRerun = false,
	btnTooltip,
}: CheckListActionsProps) => {
	return (
		<div className={styles.actionsWrapper}>
			{showRerun ? (
				<Button
					className={styles.iconBtn}
					onClick={handleRerun}
					icon={
						<span className={styles.iconBtnHolder}>
							<span className={styles.iconBtnInner}>
								<Rerun />
							</span>
						</span>
					}
					value="Re-generate"
					iconPosition="right"
					variant="link"
				/>
			) : (
				<>
					<Tooltip title={btnTooltip}>
						<Button
							className={styles.iconBtn}
							onClick={handleViewResult}
							icon={
								<span className={styles.iconBtnHolder}>
									<span className={styles.iconBtnInner}>
										<PlayIcon />
									</span>
								</span>
							}
							value="view result"
							iconPosition="right"
							variant="link"
							disabled={isDisabledViewBtn}
						/>
					</Tooltip>
					{handleDownload && (
						<Tooltip title={btnTooltip}>
							<Button
								onClick={handleDownload}
								icon={
									<Download className={styles.iconDownload} />
								}
								btnIcon
								variant="secondary"
								isLoading={isLoading || isDownloading}
								disabled={isDisabled}
							/>
						</Tooltip>
					)}
				</>
			)}
		</div>
	);
};

export default CheckListActions;
